<template>
     <div class="snippet event-domain-snippet">
        


        <div class="form-group row">
            <div class="col-lg-12">

                <div id ="multiple_images">
                    <input
                        placeholder="Upload Multiple Images"
                        type="file"
                        class="form-control"
                        @change="updateFlags"
                        multiple="multiple"
                        accept="image/jpeg"
                        dimmention="397X1000"
                      >
                      <p> (Should be in image format-Max Limit 20 and JPEG only)</p>
                 
                </div>
            </div>
            <div class="image-list">
                        <div class="image-item" v-for="file in item.flag" v-bind:key="file">
                        <img :src="IMAGE_URL + file.key" alt="Image 1" >
                        <div class="image-details">
                            <span class="image-name">{{getFileName(file.key)}}</span>
                            <button type="button" class="remove-btn" @click="removeAssetfile($event, file.key)">Remove</button>
                        </div>
                        </div>
                </div>
        </div>




    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import constants from "@/config/constants";
   
import { upload, remove } from "@/services/FileUploader";
import ObjectID from 'bson-objectid';
export default {
    name: "FlagsTab",
    data() {
        return {
            IMAGE_URL:constants.IMAGE_URL
        }
       
    },
    computed: {
        ...mapGetters("EventHallsSingle", [
            "item",
        ])
    },
    methods: {
        ...mapActions("EventHallsSingle", [
            "setFlags",
            "removeFlags"
        ]),
        getFileName(str){
                let stringNew =  str.split("/").pop();
                return stringNew.slice(-25);
        },
        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },
        async updateFlags(e){
                try {
                    let image_qty = 20;
                    let totalDocs = this.item.flag.length + e.target.files.length;
                    if (totalDocs > image_qty) {
                        alert(`You can not upload more than ${image_qty} Flag in the Event Hall`);
                        return;
                    }
                    const files = e.target.files;
                    for(let file of files){
                        let file_size = file.size;
                           let img_ext = file.name.split('.').pop().toLowerCase();
                            if(['jpg','jpeg'].includes(img_ext) ==false){
                                this.errCb();
                                return;
                                
                            }
                        
                        
                        
                    }
                    const user = JSON.parse(localStorage.getItem('user'));
                    for(let file of files){
                        let file_size = file.size;
                        let id = ObjectID();
                        let resp = await upload(file, id, "event-hall", '234X900', 'flags');
                        let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                        let extension = fileKey.split('.').pop();
                        this.setFlags({
                            key: fileKey,
                            old_key: fileKey,
                            temp_key: id,
                            size: file_size.toString(),
                            extension: extension,
                            uploadedBy: user.first_name + ' ' + user.last_name,
                            uploadedAt: '2023.01.01',
                        });
                    }
                    
                } catch (e) {
                    console.log("Error in set",e);
                    this.$flashMessage.show({
                    group: 'event_hall_index',
                    type: 'error',
                    title: 'Error',
                    html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                    });
                }
            },
        removeAssetfile(e, id) {
            console.log("removeid",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeFlags(id);
                    })
                }
            });
        },
        errCb(e){
            this.$flashMessage.show({
                group : 'event_hall_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        }
        

    }
}
</script>

<style scoped>

</style>